/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import { Card, Dialog, Icon, IconButton } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import ExperienceData from "../../tables/data/experienceTableData";
import EducationsData from "../../tables/data/educationTableData";

import MDAvatar from "components/MDAvatar";
import building from "assets/images/building.png";

import { useLocation } from "react-router-dom";
import profileIcon from "assets/images/profile.png";
import { useEffect, useState } from "react";
import { getProfile } from "api";
import moment from "moment";
import { Capitalize } from "utilities";
import MDButton from "components/MDButton";
import CloseIcon from "@mui/icons-material/Close";

function JobDetail() {
  const { sales, tasks } = reportsLineChartData;

  const location = useLocation();
  const { job } = location.state || {};

  const JobLocation = () => {
    const jobTypeNames = job?.jobType.map((i) => i?.name).join(", ");

    const location = job?.location?.join(", ") || "";

    return (
      <MDBox p={3}>
        <MDTypography variant="h5">{job?.title}</MDTypography>

        <MDTypography variant="h6" mt={3}>
          Job Location
        </MDTypography>

        <MDTypography mb={0.25} display="block" variant="caption">
          {location}
        </MDTypography>
      </MDBox>
    );
  };

  const CompanyDetail = () => {
    const imgWidth = job?.company?.businessImageURL ? "100%" : "50%";
    const imgHeight = job?.company?.businessImageURL ? "100%" : "50%";
    const imgResize = job?.company?.businessImageURL ? "cover" : "contain";

    return (
      <MDBox p={3} display="flex" gap={2}>
        <MDAvatar
          src={job?.company?.businessImageURL || building}
          size="sm"
          sx={{
            width: "70px", // optional: control size
            height: "70px", // optional: control size
            border: "2px solid",
            borderColor: "success.main",
            "& img": {
              width: imgWidth,
              height: imgHeight,
              objectFit: imgResize,
              objectPosition: "center",
            },
          }}
        />
        <MDBox>
          <MDTypography display="block" variant="h5" fontWeight="medium" mb={0.5}>
            {job?.company?.businessName}
          </MDTypography>
          <MDTypography mb={0.25} display="block" variant="caption">
            {`${job?.company?.city}, ${job?.company?.state}, ${job?.company?.country}`}
          </MDTypography>

          <MDTypography mb={0.25} display="block" variant="caption">
            {`${job?.company?.code} ${job?.company?.phone}`}
          </MDTypography>
          <MDTypography mb={0.25} display="block" variant="caption">
            {`${job?.company?.email}`}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  const ViewJob = () => {
    const jobTypeNames = job?.jobType.map((i) => i?.name).join(", ");

    const location = job?.location?.join(", ") || "";

    return (
      <MDBox p={3}>
        <MDTypography variant="h5">{job?.title}</MDTypography>

        <MDTypography variant="h6" mt={3}>
          Job Location
        </MDTypography>
        <MDTypography mb={0.25} display="block" variant="caption">
          {location}
        </MDTypography>

        <MDTypography variant="h6" mt={3}>
          Salary Range
        </MDTypography>
        <MDTypography mb={0.25} display="block" variant="caption">
          {`₹${job?.salary?.min} - ₹${job?.salary?.max}/month`}
        </MDTypography>

        <MDTypography variant="h6" mt={3}>
          Job Type
        </MDTypography>
        <MDTypography mb={0.25} display="block" variant="caption">
          {jobTypeNames}
        </MDTypography>

        <MDTypography variant="h6" mt={3}>
          Experience Level
        </MDTypography>
        <MDTypography mb={0.25} display="block" variant="caption">
          {`${job?.experience?.min} - ${job?.experience?.max} years`}
        </MDTypography>
      </MDBox>
    );
  };

  const ViewJobDescription = () => {
    return (
      <MDBox pl={3} pb={3}>
        <MDTypography variant="h6" mt={3}>
          Job Description
        </MDTypography>
        <MDTypography mb={0.25} display="block" variant="caption">
          {job?.description}
        </MDTypography>
      </MDBox>
    );
  };

  const ViewJobRequirement = () => {
    return (
      <MDBox pl={3} pb={3}>
        <MDTypography variant="h6" mt={3}>
          Requirements
        </MDTypography>
        <MDTypography mb={0.25} display="block" variant="caption">
          {job?.requirement}
        </MDTypography>
      </MDBox>
    );
  };

  const ViewJobBenefits = () => {
    return (
      <MDBox pl={3} pb={3}>
        <MDTypography variant="h6" mt={3}>
          Perks & Benefits
        </MDTypography>
        <MDTypography mb={0.25} display="block" variant="caption">
          {job?.benefits}
        </MDTypography>
      </MDBox>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title={"Job Detail"} />
      <MDBox py={3}>
        <Card>
          <CompanyDetail />
          <ViewJob />
          <ViewJobDescription />
          <ViewJobRequirement />
          <ViewJobBenefits />
        </Card>
      </MDBox>
      <MDBox mb={2} />
      <Footer />
    </DashboardLayout>
  );
}

export default JobDetail;
